import { connect } from "react-redux";

import _ from "lodash";
//import moment from 'moment'

import React from "react";

import {
  Card,
  List,
  Modal,
  Header,
  Segment,
  Dimmer,
  Loader
} from "semantic-ui-react";

import { fetchDetailData } from "../Actions/DashboardActions";
const maxPreviewSize = 5;
const productListSectionFields = [
  {
    field: "TRADE_NAME",
    title: "Trade Name",
    format: item => {
      return item;
    }
  },
  {
    field: "PRODUCT_FLAG",
    title: "Product Flag",
    format: item => {
      return item;
    }
  }
];
class ProductDetailView extends React.Component {
  state = { modalOpen: false };

  handleOpen = () => {
    this.props.fetchDetailData();
    this.setState({ modalOpen: true });
  };

  handleClose = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    const noProductsView = <div>No Products For This Case</div>;

    const productCards = (
      <Card.Group>
        {_.map(this.props.product_detail, (product, idx) => {
          let productListSection;
          const productListSectionIsDefined = _.some(
            productListSectionFields,
            section => {
              return (
                !_.isUndefined(product[section.field]) &&
                product[section.field] !== null
              );
            }
          );
          if (productListSectionIsDefined) {
            productListSection = (
              <Card.Content>
                <List>
                  {_.reduce(
                    productListSectionFields,
                    (result, section, idx) => {
                      if (
                        !_.isUndefined(product[section.field]) &&
                        product[section.field] !== null
                      ) {
                        result.push(
                          <List.Item key={idx}>
                            <List.Header>{section.title}</List.Header>
                            {section.format(product[section.field])}
                          </List.Item>
                        );
                      }
                      return result;
                    },
                    []
                  )}
                </List>
              </Card.Content>
            );
          }

          return (
            <Card fluid key={idx}>
              {productListSection}
            </Card>
          );
        })}
      </Card.Group>
    );

    const products = _.compact(_.map(this.props.products, _.trim));
    const hasProductDataButMissingNames = (this.props.products || []).length > 0 && (products || []).length === 0;
    const modalTrigger = hasProductDataButMissingNames ? (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={'View Product Details'}>
          View Product Details
        </div>
      </a>
    ) :
    (
      <a>
        <div style={{ cursor: "pointer" }} onClick={this.handleOpen} title={products.join(', ')}>
          {(products.slice(0, maxPreviewSize) || []).join(", ")}
          {products.length > maxPreviewSize ? "..." : ""}
        </div>
      </a>
    );

    return (
      <Modal
        trigger={modalTrigger}
        open={this.state.modalOpen}
        onClose={this.handleClose}
        size="small"
      >
        <Header content="Products" />
        <Modal.Content scrolling>
          {this.props.fetching_product_detail && (
            <Segment style={{ height: "50vh" }}>
              <Dimmer active>
                <Loader>Loading</Loader>
              </Dimmer>
            </Segment>
          )}
          {!this.props.fetching_product_detail &&
            (this.props.product_detail.length > 0
              ? productCards
              : noProductsView)}
        </Modal.Content>
      </Modal>
    );
  }
}

//Binds the current Redux state to props that the sub component (DashboardView) uses
const mapStateToProps = (state, ownProps) => {
  return {
    product_detail: _.get(state, "dashboard.product_detail") || [],
    fetching_product_detail:
      _.get(state, "dashboard.fetching_product_detail") || false
  };
};

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDetailData: () => {
      dispatch(fetchDetailData(ownProps.record_id, "product_detail"));
    }
  };
};

//Boilerplate code to connect the subcomponent to the Redux state - automatically determines if the subcomponent should update when the state is updated
export const ProductDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailView);

export default ProductDetail;



// WEBPACK FOOTER //
// ./src/Components/ProductDetail.jsx